import React from 'react';
import GrayTag from './_base/GrayTag';

export default function MissingFieldsTag(props) {
  return (
    <GrayTag label="MISSING FIELDS" />
  );
}
